import React from "react";

const KnowYourSize = () => {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html:
            "\n      .shoe-s-table th {\n        background-color: #c6034e;\n        color: #fff;\n      }\n      .shoe_s-size h1.title {\n        font-size: 20px;\n        color: #c6034e;\n        font-weight: 700;\n        padding-right: 10px;\n      }\n      .shoe-s-table tr:nth-of-type(odd) td {\n        background: #eee;\n      }\n      .shoe-s-table > thead > tr > th,\n      .shoe-s-table > tbody > tr > th,\n      .shoe-s-table > tfoot > tr > th,\n      .shoe-s-table > thead > tr > td,\n      .shoe-s-table > tbody > tr > td,\n      .shoe-s-table > tfoot > tr > td {\n        padding: 8px;\n        line-height: 1.428571429;\n        border-top: 1px solid #ddd;\n        text-align: right;\n      }\n      .shoe_s-size ul {\n        padding-left: 0;\n      }\n      .shoe_s-size ul li {\n        list-style: none;\n      }\n    ",
        }}
      />
      <section className="shoe_s-size my-3">
        <div className="container">
          <div className="bg">
            <h1 className="title text-center">Shoe size calculator</h1>
            <div className="row">
              <div className="col-sm-12">
                <h2>How to measure the size of your feet</h2>
                <p>
                  Shoe sizes are measured different among many countries and
                  shoe stores. We find it important that you order the right
                  shoe size and don't have to return your shoes because of this.
                  This page explains how to measure your feet and how to find
                  the right size for you.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-8">
                <p>To calculate your shoe size in centimeters or inches:</p>
                <ul>
                  <li>a. Place your longest foot on a piece of paper</li>
                  <li>
                    b. Do this at the end of the day (your feet will be bigger)
                  </li>
                  <li>
                    c. Put your weight on this foot; this will make your foot
                    bigger
                  </li>
                  <li>d. Draw a line around your foot</li>
                  <li>
                    e. Measure the size between the tip of the big toe and the
                    end of your foot (beginning of the heel)
                  </li>
                  <li>
                    <strong>f. Add 1 cm (or 0.4") to the size</strong>
                  </li>
                </ul>
                <p>
                  With this measurement of the foot, you can look up in the
                  table below which size of our shoes corresponds to it.
                </p>
                <p>
                  Please note; the cm/Inch are averages, there are differences
                  between them. The fit and sometimes the last size of different
                  manufacturers are different. That is why we have put a fit
                  code (e.g. D7) next to shoes that are made on the same last,
                  and therefore have the same fit, so you know that this shoe is
                  the right size for you.
                </p>
                <p>
                  Not sure about the size and/or want to know the exact size of
                  the shoe? Please contact us
                </p>
              </div>
              <div className="col-sm-4">
                <img
                  src="https://stravers.shoes/images/sizes/foot-size-measure.png"
                  alt="Foot size measure help"
                  className="img-responsive"
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <h2>Shoe sizes conversion table</h2>
                <table className="table shoe-s-table">
                  <thead>
                    <tr>
                      <th>cm</th>
                      <th>inch</th>
                      <th>EU size</th>
                      <th>UK size</th>
                      <th>US size Men</th>
                      <th>US size Women</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>19</td>
                      <td>7.66</td>
                      <td>31</td>
                      <td>0000</td>
                      <td />
                      <td>0</td>
                    </tr>
                    <tr>
                      <td>19.4</td>
                      <td>8</td>
                      <td>32</td>
                      <td>00</td>
                      <td />
                      <td>1</td>
                    </tr>
                    <tr>
                      <td>20</td>
                      <td>8.3</td>
                      <td>33</td>
                      <td>00</td>
                      <td />
                      <td>1.5</td>
                    </tr>
                    <tr>
                      <td>20.8</td>
                      <td>8.5</td>
                      <td>34</td>
                      <td>1</td>
                      <td />
                      <td>2.5</td>
                    </tr>
                    <tr>
                      <td>22</td>
                      <td>8.66</td>
                      <td>35</td>
                      <td>2</td>
                      <td />
                      <td>3.5</td>
                    </tr>
                    <tr>
                      <td>22.9</td>
                      <td>9</td>
                      <td>36</td>
                      <td>3</td>
                      <td>4.5</td>
                      <td />
                    </tr>
                    <tr>
                      <td>23.3</td>
                      <td>9.17</td>
                      <td>37</td>
                      <td>4</td>
                      <td>6</td>
                      <td />
                    </tr>
                    <tr>
                      <td>24.1</td>
                      <td>9.5</td>
                      <td>38</td>
                      <td>5</td>
                      <td>7</td>
                      <td />
                    </tr>
                    <tr>
                      <td>24.6</td>
                      <td>9.66</td>
                      <td>39</td>
                      <td>6</td>
                      <td>8</td>
                      <td />
                    </tr>
                    <tr>
                      <td>27.1</td>
                      <td>10.7</td>
                      <td>42</td>
                      <td>8</td>
                      <td />
                      <td>10</td>
                    </tr>
                    <tr>
                      <td>27.5</td>
                      <td>10.8</td>
                      <td>43</td>
                      <td>9</td>
                      <td />
                      <td>11</td>
                    </tr>
                    <tr>
                      <td>27.9</td>
                      <td>11</td>
                      <td>44</td>
                      <td>10</td>
                      <td />
                      <td>11.5</td>
                    </tr>
                    <tr>
                      <td>28.8</td>
                      <td>11.3</td>
                      <td>45</td>
                      <td>10.5</td>
                      <td />
                      <td>12</td>
                    </tr>
                    <tr>
                      <td>29.2</td>
                      <td>11.5</td>
                      <td>46</td>
                      <td>11</td>
                      <td />
                      <td>13</td>
                    </tr>
                    <tr>
                      <td>30.1</td>
                      <td>11.8</td>
                      <td>47</td>
                      <td>12</td>
                      <td>13.5</td>
                      <td>14</td>
                    </tr>
                    <tr>
                      <td>30.9</td>
                      <td>12.2</td>
                      <td>48</td>
                      <td>13</td>
                      <td>14.5</td>
                      <td>15</td>
                    </tr>
                    <tr>
                      <td>31.3</td>
                      <td>12.3</td>
                      <td>49</td>
                      <td>13.5</td>
                      <td>15.5</td>
                      <td />
                    </tr>
                    <tr>
                      <td>32.1</td>
                      <td>13.1</td>
                      <td>50</td>
                      <td>14</td>
                      <td>16</td>
                      <td />
                    </tr>
                    <tr>
                      <td>32.9</td>
                      <td>13.4</td>
                      <td>51</td>
                      <td>15</td>
                      <td>17.5</td>
                      <td />
                    </tr>
                    <tr>
                      <td>33.7</td>
                      <td>13.7</td>
                      <td>52</td>
                      <td>16</td>
                      <td>18.5</td>
                      <td />
                    </tr>
                    <tr>
                      <td>34.5</td>
                      <td>14</td>
                      <td>53</td>
                      <td>17</td>
                      <td>19.5</td>
                      <td />
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default KnowYourSize;
